var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "my-spin",
    class: _vm.wrapperClasses
  }, [_vm.loading && _vm.isDelayOver ? _c("div", {
    staticClass: "my-spin__loading",
    class: _vm.spinClasses
  }, [_vm._t("dot", function () {
    return [_vm._m(0)];
  }), _c("div", {
    staticClass: "my-spin__text"
  }, [_vm._t("text", function () {
    return [_vm._v(_vm._s(_vm.tip))];
  })], 2)], 2) : _vm._e(), _vm.$slots.default ? _c("div", {
    staticClass: "my-spin__container",
    class: _vm.containerClasses
  }, [_vm._t("default")], 2) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "my-spin__dot"
  }, [_c("i", {
    staticClass: "my-spin__dot-item"
  }), _c("i", {
    staticClass: "my-spin__dot-item"
  }), _c("i", {
    staticClass: "my-spin__dot-item"
  }), _c("i", {
    staticClass: "my-spin__dot-item"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };